module.exports = __webpack_public_path__ + "images/radnicki_portal-41406ec253278cd95d8f2e3e75b20d4b.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/radnicki_portal.png
// module id = 54
// module chunks = 0